import { useQuery } from '@tanstack/react-query';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import { conventionService } from '../../services/convention.service';

interface NotificationBadgeProps {
  children: React.ReactNode;
}

export default function NotificationBadge({ children }: NotificationBadgeProps) {
  const { data } = useQuery({
    queryKey: ['phases', 'overdue'],
    queryFn: () => conventionService.getOverduePhases(),
    refetchInterval: 5 * 60 * 1000, //Cada 5  minutos
    staleTime: 4 * 60 * 1000,
  });

  const overdueCount = data?.total || 0;

  if (overdueCount === 0) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={`${overdueCount} fase(s) vencida(s) requieren atención`}>
      <Badge
        badgeContent={overdueCount}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.65rem',
            minWidth: 18,
            height: 18,
          },
        }}
      >
        {children}
      </Badge>
    </Tooltip>
  );
}
